export enum EbixStaffActionTypes {
  API_RESPONSE_SUCCESS = "@@ebix_staff/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@ebix_staff/API_RESPONSE_ERROR",
  CREATE_EBIX_STAFF = "@@ebix_staff/CREATE_EBIX_STAFF",
  GET_EBIX_STAFF = "@@ebix_staff/GET_EBIX_STAFF",
  GET_DOCS = "@@ebix_staff/GET_DOCS",
  UPLOAD_SWIFT = "@@ebix_staff/UPLOAD_SWIFT",
  GET_SWIFT = "@@ebix_staff/GET_SWIFT",
  GET_DETAILS = "@@ebix_staff/GET_DETAILS",
  DELETE_EBIX_STAFF = "@@ebix_staff/DELETE_EBIX_STAFF",
  UPDATE_BOOKING_STATUS = "@@ebix_staff/UPDATE_BOOKING_STATUS",
}
